export default "/_next/static/images/a2226343784486a07eb05de9c356ce9c.png";